import { Component, OnInit } from '@angular/core';
import {IOption} from "ng-select";
import {BsModalRef} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";

@Component({
  selector: 'app-report-rir-print-preview-almaha',
  templateUrl: './report-rir-print-preview-almaha.component.html',
  styleUrls: ['./report-rir-print-preview-almaha.component.scss'],
  providers: [RilrService, HelperService]
})
export class ReportRirPrintPreviewAlmahaComponent implements OnInit {

  public masterData: any = {};
  public incidentColspan: number = 0;
  public reportSystemID: number;
  public documentSystemID: number;
  public documentTypeLabel: string = "incident report";
  public incidentTypeArr= [];
  public incidentTypeArrAll= [];
  public companySystemID = +this.helperService.getSelectedCompanyId();
  public incidentCategoryArr: any[];
  public reportCategoryArr: any[];
  public incidentSubCategoryArr: any[];
  public incidentSubCategoryDynamicArr: any[];
  public findingClassificationTbl: any = [];
  public correctiveActionsTbl: any = [];
  public auditorsInformationTbl: any = [];
  public meetingAttendees: any = [];
  public meetingClientsAndContractors: any = [];
  public injuredDetails: any = [];
  public immediateCauses: any = [];
  public rootCauses: any = [];
  public incidentCost: any = [];
  public reportCheckList: any = [];

  public incidentNotificationMultipleOneArr: any = [];
  public incidentNotificationMultipleTwoArr : any = [];
  public incidentNotificationMultipleThreeArr : any = [];
  public incidentNotificationMultipleFourArr : any = [];
  public incidentNotificationMultipleFiveArr : any = [];
  public incidentNotificationMultipleSixArr : any = [];
  public incidentNotificationMultipleSevenArr : any = [];

  public reportCheckListCategory: any = {};
  yesNoArr1: any = [
    {value: 1, label: 'No'},
    {value: 2, label: 'Yes'}
  ];
  public methodEvacuation: any = [
    {value: 1, label: "Manual activation of alarm at fire indicator board"},
    {value: 2, label: "Other"}
  ];

  constructor(public bsModalRef: BsModalRef,
              private helperService: HelperService,
              private spinner: NgxSpinnerService,
              private rilrService: RilrService) {
  }

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.reportPrintPreview();
    }, 0);

  }

  public reportPrintPreview() {
    const that = this;
    that.rilrService
      .reportPrintPreviewDataAlmaha()
      .get({
        companySystemID: that.companySystemID,
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID
      })
      .subscribe(data => {
        const resp = data.data.data;
        that.incidentTypeArr = that.helperService.incidentsIdChangeToInt(resp.incidents);
        that.incidentTypeArrAll = that.helperService.incidentsIdChangeToInt(resp.incidentsAll);
        that.incidentCategoryArr = resp.incidentCategory;
        that.reportCategoryArr = resp.reportCategory;
        that.incidentSubCategoryArr = resp.IncidentSubCategory;
        that.masterData = resp.reportData;
        that.incidentSubCategoryDynamicArr = resp.incidentDynamicSubCategory;
        that.correctiveActionsTbl = resp.actions;
        that.auditorsInformationTbl = resp.auditorDetails;
        that.documentTypeLabel = resp.document.documentDescription;
        that.meetingAttendees = resp.meetingAttendees;
        that.meetingClientsAndContractors = resp.meetingClientsAndContractors;
        that.injuredDetails = resp.injuredDetails;
        that.immediateCauses = resp.immediateCauses;
        that.rootCauses = resp.rootCauses;
        that.incidentCost = resp.incidentCost;
        that.reportCheckList = resp.reportCheckList;
        that.reportCheckListCategory = resp.reportCheckListCategory;

        that.incidentNotificationMultipleOneArr = resp.detailOne;
        that.incidentNotificationMultipleTwoArr = resp.detailTwo;
        that.incidentNotificationMultipleThreeArr = resp.detailThree;
        that.incidentNotificationMultipleFourArr = resp.detailFour;
        that.incidentNotificationMultipleFiveArr = resp.detailFive;
        that.incidentNotificationMultipleSixArr = resp.detailSix;
        that.incidentNotificationMultipleSevenArr = resp.detailSeven;
        that.findingClassificationTbl = resp.findingMaster;

        setTimeout(() => {
          if(!that.incidentTypeArr.some((incident) => incident.id == that.masterData.reportNewSystemID)){
            let incidentIndex = that.incidentTypeArrAll.findIndex(i => i.id == that.masterData.reportNewSystemID)
            if(incidentIndex > -1){
              that.incidentTypeArr.push(that.incidentTypeArrAll[incidentIndex])
            }
          }
          that.incidentColspan = that.incidentTypeArr.length;
        }, 0);
     
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
      });
  }

  public rowspanCalculator(segmentID){
    if(segmentID == 29){
      return 9;
    }else if (segmentID == 30){
      return 50;
    }else if (segmentID == 31){
      return 58;
    }else if (segmentID == 32){
      return 40;
    }else if (segmentID == 33){
      return 7;
    }else if (segmentID == 34){
      return 6;
    }else if (segmentID == 35){
      return 11;
    }else if (segmentID == 36){
      return 7;
    }else if (segmentID == 37){
      return 2;
    }else if (segmentID == 38){
      return 4;
    }else if (segmentID == 39){
      return 16;
    }else if (segmentID == 40){
      return 20;
    }else if (segmentID == 41){
      return 43;
    }else if (segmentID == 42){
      return 10;
    }else if (segmentID == 43){
      return 6;
    }else if (segmentID == 43){
      return 6;
    }else if (segmentID == 44){
      return 12;
    }else if (segmentID == 45){
      return 17;
    }else if (segmentID == 46){
      return 11;
    }else if (segmentID == 47){
      return 22;
    }else if (segmentID == 48){
      return 13;
    }
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  public print_pdf_preview() {
    // const urlGeneratingPdf = 'api/v1/printReportPDF?id=' + this.reportSystemID + '&documentSystemID=' + this.documentSystemID + '&companySystemID=' + this.companySystemID;
    //  window.open(urlGeneratingPdf, '_blank');
    const that = this;
    that.rilrService
      .printRIRReportPDFAlmaha()
      .get({
        id: that.reportSystemID,
        documentSystemID: that.documentSystemID,
        companySystemID: that.companySystemID,
      })
      .subscribe(resp => {
        const data = resp.data.data;
        window.open(data.pdf_path, "_blank");
      }, (error) => {
        if (error.status == 500) {
          //that.tosterMessageService.showError("Error", error.data.message);
        }
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/report-rir-print-preview-almaha/report-rir-print-preview-almaha.component.ts